/**
 * Wanneer het gespreksscherm mee omlaag mag scrollen, en hoe.
 *
 * **WAAROM DIT EEN EIGEN BESTAND IS EN GEEN `if` IN HET EFFECT.** Huisregel
 * 4.8c: een beslissing die middenin een component staat, is alleen met een
 * bronscan te toetsen, en een bronscan blijft groen boven code die de regel
 * wel DRAAGT en niet UITVOERT. Als pure functie is zij op UITKOMST te toetsen
 * en valt een mutatie er wel op om.
 *
 * **HET GEBREK DAT DIT REPAREERT, gemeld door Frank op 24 augustus 2026:**
 * "ik kan tijdens en na het antwoord niet meer scrollen". `ChatArea.jsx` deed
 * bij ELKE wijziging van `messages` een `scrollIntoView({behavior:"smooth"})`,
 * zonder te kijken waar de lezer stond. Omdat de backend een afgerond antwoord
 * in stukjes van tien tekens uitdeelt met 20 ms ertussen, was dat 351 keer een
 * nieuwe vloeiende scroll bij het langste antwoord in Franks database - elke
 * 20 ms een, die zijn eigen scrollen steeds overnam. Dat is geen traagheid
 * maar een INGREEP, en daarom is de reparatie een voorwaarde en geen versnelling.
 * De regel stond er sinds 23 december 2025 (`40e4fb4`).
 */

/** Hoeveel pixels je van de onderkant af mag zitten en toch "onderaan" heet.
 *
 *  Een regel tekst is ongeveer 24 px, dus dit is een kleine drie regels
 *  speling. Nul zou onbruikbaar zijn: een halve pixel afronding in de browser
 *  of een afbeelding die inlaadt zou je dan al als "weggescrold" tellen, en
 *  dan scrolt het scherm nooit meer mee terwijl je wel onderaan staat.
 */
export const DREMPEL_PX = 80;

/** Staat de lezer onderaan?
 *
 *  Neemt de drie getallen los aan in plaats van een DOM-element, zodat de
 *  regel te toetsen is zonder browser. Dat is het hele punt van dit bestand.
 */
export function staatOnderaan({ scrollTop, scrollHeight, clientHeight }, drempel = DREMPEL_PX) {
  const afstand = scrollHeight - scrollTop - clientHeight;
  return afstand <= drempel;
}

/** Mag er meegescrold worden?
 *
 *  **Twee redenen, en de eerste overrulet de tweede met opzet.** Een NIEUW
 *  bericht is bijna altijd het bericht dat de lezer zojuist zelf verstuurde,
 *  en dan omlaag springen is precies wat hij bedoelde. Groeit een bestaand
 *  bericht (het antwoord dat binnenkomt), dan telt alleen waar hij stond.
 */
export function magMeescrollen({ nieuwBericht, stondOnderaan }) {
  return Boolean(nieuwBericht || stondOnderaan);
}

/** Vloeiend of meteen.
 *
 *  **Vloeiend scrollen is een ANIMATIE, en een animatie die elke 20 ms opnieuw
 *  begint komt nooit aan.** Tijdens het binnenkomen van een antwoord is
 *  "auto" daarom niet de zuinige keuze maar de enige juiste: de sprong is
 *  klein, want er komt telkens maar een klein stukje bij. Vloeiend blijft
 *  over voor het moment waarop het wel iets toevoegt, namelijk een nieuw
 *  bericht op een rustig scherm.
 */
export function gedragVoor(isStreaming) {
  return isStreaming ? "auto" : "smooth";
}
